import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tripDetailsTokens as t } from "./trip-details.tokens";
import { BudgetBreakdownGrid, BudgetBreakdownItem, BudgetBreakdownLabel, BudgetBreakdownValue, BudgetTotal, BudgetTotalLabel, BudgetTotalValue, } from "./trip-budget.style";
import TripSectionCard from "./TripSectionCard";
var formatAmount = function (amount, currency) {
    if (amount == null || Number.isNaN(amount))
        return "—";
    try {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: currency,
            maximumFractionDigits: 0,
        }).format(amount);
    }
    catch (_a) {
        return "".concat(currency, " ").concat(amount.toLocaleString());
    }
};
var TripBudgetCard = function (_a) {
    var _b;
    var budget = _a.budget;
    var currency = budget.currency || "INR";
    var items = ((_b = budget.budgetItems) !== null && _b !== void 0 ? _b : []).filter(function (item) { return item.amount != null && item.amount > 0; });
    if (!budget.totalBudget && items.length === 0) {
        return null;
    }
    return (_jsxs(TripSectionCard, { title: "Approximate Budget", icon: "\uD83D\uDCB0", iconBg: t.greenBg, children: [_jsxs(BudgetTotal, { children: [_jsx(BudgetTotalLabel, { children: "Estimated total per person" }), _jsx(BudgetTotalValue, { children: formatAmount(budget.totalBudget, currency) })] }), items.length > 0 && (_jsx(BudgetBreakdownGrid, { children: items.map(function (item) { return (_jsxs(BudgetBreakdownItem, { children: [_jsx(BudgetBreakdownLabel, { children: item.categoryName }), _jsx(BudgetBreakdownValue, { children: formatAmount(item.amount, currency) })] }, item.categoryCode)); }) }))] }));
};
export default TripBudgetCard;
